const isEmptyObject = (obj: any) => 
    obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length === 0;
  
  const isEmptyArray = (arr: any) => Array.isArray(arr) && arr.length === 0;
  
  export const filterObject = (obj: any): any => {
    const filteredObj: any = {};
  
    // Iterate over the entries of the input object
    Object.entries(obj).forEach(([key, value]) => {
      // Add the value to the filtered object if it's valid
      if (value !== null && value !== undefined && value !== "") {
        if (typeof value === 'object' && !Array.isArray(value)) {
          if (!isEmptyObject(value)) {
            filteredObj[key] = value;
          }
        } else if (Array.isArray(value)) {
          if (!isEmptyArray(value)) {
            filteredObj[key] = value;
          }
        } else {
          filteredObj[key] = value;
        }
      }
    });
  
    return filteredObj;
  };


  export function convertCurlToJson(curlCommand: string) {
    const jsonOutput: any = {
      method: '',
      url: '',
      headers: {},
      data: {}
    };
  
    const methodRegex = /--request\s+([A-Z]+)/;
    const urlRegex = /'([^']+)'/;
    const headerRegex = /--header\s+'([^']+)'/g;
    const dataRegex = /--data(?:-raw)?\s+'([^']+)'/;
  
    // Extract method (GET, POST, etc.)
    const methodMatch = curlCommand.match(methodRegex);
    jsonOutput.method = methodMatch ? methodMatch[1] : 'GET';
  
    // Extract URL
    const urlMatch = curlCommand.match(urlRegex);
    jsonOutput.url = urlMatch ? urlMatch[1] : '';
  
    // Extract headers
    let headerMatch;
    while ((headerMatch = headerRegex.exec(curlCommand)) !== null) {
      const headerParts = headerMatch[1].split(':');
      const headerKey = headerParts[0].trim();
      const headerValue = headerParts[1].trim();
      jsonOutput.headers[headerKey] = headerValue;
    }
  
    // Extract data (if any) for --data or --data-raw
    const dataMatch = curlCommand.match(dataRegex);
    if (dataMatch) {
      // Try parsing as JSON, if that fails, just use as a string
      try {
        jsonOutput.data = JSON.parse(dataMatch[1]);
      } catch (e) {
        jsonOutput.data = dataMatch[1];
      }
    }
  
    return jsonOutput;
  }

  export const createDataFromHeadersOrParams = (data: Array<{ key: string; value: string }>) => {
    return data.reduce((acc, { key, value }) => {
      acc[key] = value;
      return acc;
    }, {} as Record<string, string>);
  };
  
  export const createArrayFromObject = (data: Record<string, string>, p0: never[]) => {
    return Object.entries(data).map(([key, value]) => ({ key, value }));
  };
  
  
  
  
  export const JsonViewTheme = {
    scheme: "dark-custom",
    base00: "#1f1f1f", // Dark grey base background (primary)
    base01: "#313131", // Slightly darker grey for nested nodes or subtle contrasts
    base02: "#666666", // Medium grey for subtle background contrast
    base03: "#7E8392", // Grey for comments, metadata, and secondary text
    base04: "#CBCDD3", // Light grey for borders and dividers
    base05: "#FFFFFF", // Primary text color (white)
    base06: "#F1F1F1", // Lighter grey for highlights and interactive elements
    base07: "#F9F9F9", // Very light grey for strong highlights
    base08: "#FF4E6A", // Neon pink for error messages or critical labels
    base09: "#FF9F47", // Accent orange for warnings or highlights
    base0A: "#FFD700", // Neon yellow for notices or attention-grabbing elements
    base0B: "#00FFAA", // Neon green for success messages or confirmations
    base0C: "#00FFFF", // Neon cyan for links, keys, or identifiers
    base0D: "#008BFF", // Neon blue for focus or highlighted elements
    base0E: "#C084FC", // Neon lavender for accent details
    base0F: "#FF8C00", // Neon orange for deeper highlights and accents

    // Define custom colors for specific JSON data types
    string: {
      color: "#FF6347", // Tomato red for string values
    },
    number: {
      color: "#32CD32", // Lime green for numbers
    },
    boolean: {
      color: "#FFD700", // Gold for boolean values
    },
    null: {
      color: "#FF4500", // Orange red for null values
    },
    object: {
      color: "#1E90FF", // Dodger blue for objects
    },
    array: {
      color: "#8A2BE2", // Blue violet for arrays
    },
    key: {
      color: "#ADFF2F", // Green yellow for keys/labels
    },

    tree: {
      style: {
        fontSize: "18px",
        fontFamily: "Arial, sans-serif",
        fontWeight: "bold", // Make font bold
      },
    },
  };
  
  
